// in src/App.js
import React from 'react';
import { jsonServerRestClient, Admin, Resource, Delete, resolveBrowserLocale, englishMessages } from 'admin-on-rest';

import italianMessages from 'aor-language-italian';
import frenchMessages from 'aor-language-french';

// domain translations
import * as domainMessages from './i18n';

import PostIcon from 'material-ui/svg-icons/action/book';
import UserIcon from 'material-ui/svg-icons/social/group';
import Dashboard from './Dashboard';
import authClient from './authClient';

import { PostList, PostEdit, PostCreate } from './posts';
import { UserList } from './users';

const messages = {
  it: { ...italianMessages, ...domainMessages.it },
  fr: { ...frenchMessages, ...domainMessages.fr },
  en: { ...englishMessages, ...domainMessages.en },
};

const App = () => (
  <Admin title={<AppTitle />} authClient={authClient} dashboard={Dashboard} restClient={jsonServerRestClient('https://jsonplaceholder.typicode.com')} locale={resolveBrowserLocale()} messages={messages}>
    <Resource name="posts" list={PostList} edit={PostEdit} create={PostCreate} remove={Delete} icon={PostIcon} />
    <Resource name="users" list={UserList} icon={UserIcon} />
  </Admin>
);

const appTitleStyles = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  WebkitTextOverflow: 'ellipsis',
  textOverflow: 'ellipsis',
  margin: 0,
  letterSpacing: 0,
  fontSize: 24,
  fontWeight: '400',
  color: 'rgb(255, 255, 255)',
  height: 44,
  paddingTop: 10,
  paddingBottom: 10,
  WebkitFlex: '1 1 0%',
  MsFlex: '1 1 0%',
  flex: '1 1 0%'
};

const AppTitle = () => (
  <img style={appTitleStyles} src="https://s3-eu-west-1.amazonaws.com/5loyalty/5loyalty-white.svg" />
);

export default App;


// WEBPACK FOOTER //
// ./src/App.js